


import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { addDocChamber, diagnosticList, doctorList, getShopOwnerList, hospitalList, updateDoctorData } from "../../Services/Operations/ProductAPI";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const DiagnosticCenter = () => {
  const [doctors, setDoctors] = useState([]);
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const navigate=useNavigate();
  const[selectedDoc,setSelectedDoc]=useState(null)
  const[shopList,setShopList]=useState([])
  const [selectedValue, setSelectedValue] = useState("");

  const[ editprofession,setEditprofession]=useState(selectedDoc ? selectedDoc.profession : "") ;
  const [editSpecialization,setEditSpecialization]=useState(selectedDoc ? selectedDoc.specialization : "")
  const[ editDegree,setEditDegree]=useState(selectedDoc ? selectedDoc.degree : "")
  const [editrelationWithCo,setEditrelationWithCo]=useState(selectedDoc ? selectedDoc.relationWithCo : '')
  const[editnumberOfCo,setEditnumberOfCo]=useState(selectedDoc ? selectedDoc.numberOfCo : "")
  const[editadharimage,setEditadharimage]=useState(selectedDoc?selectedDoc.aadhaarImage:null)


  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;

const indexOfLast = currentPage * itemsPerPage;
const indexOfFirst = indexOfLast - itemsPerPage;

const currentDoctors = doctors.slice(indexOfFirst, indexOfLast);


const[editmodal,setEditModal]=useState(false)


 const handleFetchShop=async()=>{
    try {
      const response=await getShopOwnerList(token)
      console.log(response);
      setShopList(response.data)
      
      
    } catch (error) {
      console.log(error);
      
    }
  }
  const fetchDoctorList = async () => {
      try {
        const response = await diagnosticList(token);
        setDoctors(response);
        console.log('hospitalList',response);
        
      } catch (error) {
        console.error("Error:", error);
      }
    };
  useEffect(() => {
  
    handleFetchShop()
    fetchDoctorList();
  }, []);

    const handleCommesionRole = () => {
    navigate("/doctor-commesion");
  };

  const handleAddChamber=async(value)=>{
    setSelectedValue(value)
    if(Number(value)===0){
      return
    }
    let body={
       doctorId: selectedDoc.id,
  shopId: Number(value)
    }
    console.log(body);
   
  
    try {
      const response=await addDocChamber({body,token})
      console.log(response);
      if(response.status===200){
        toast.success("New Chamber Added")
         handleFetchShop()
    fetchDoctorList();
    setSelectedDoc(null)
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

  useEffect(() => {
    if(editmodal && selectedDoc){
      setEditprofession(selectedDoc.profession)
      setEditSpecialization(selectedDoc.specialization)
      setEditDegree(selectedDoc.degree)
      setEditrelationWithCo(selectedDoc.relationWithCo)
      setEditnumberOfCo(selectedDoc.numberOfCo)
      setEditadharimage(selectedDoc.aadhaarImage)
    }
  }, [selectedDoc,editmodal])
  
const habdleEditDoctor=async()=>{
  try {
    let data={
      doctorId:selectedDoc.id,
      profession:editprofession,
      specialization:editSpecialization,
      degree:editDegree,
      relationWithCo:editrelationWithCo,
      numberOfCo:editnumberOfCo,
      aadhaarImage:editadharimage,
      token:token
    }
    const response=await updateDoctorData(data)
    console.log("edit doc",response);
    if(response.status===200){
      fetchDoctorList();
      toast.success("Doctor Data Updated Successfully")
    }
    
  } catch (error) {
    console.log(error);
    toast.error("Error while updating doctor data")
  }finally{
    setEditModal(false)
    setSelectedDoc(null)
  }
}
  return (
    <div id="main_content">
      <Header />
      <div className="page">
       
<Section/>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">DiagnosticCenter</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    DiagnosticCenter
                  </li>
                </ol>

              </div>
                <button
                    onClick={() => handleCommesionRole()}
                    className="btn btn-primary"
                    style={{float:"right"}}
                  >
                   Commision
                  </button>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Doctor-all">
             
              

                <div className="table-responsive card"
                style={{}}
                >
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th style={{textAlign:"center"}}>ID</th>
                        <th style={{textAlign:"center"}}>Name</th>
                        <th style={{textAlign:"center"}}>Address</th>
                        <th style={{textAlign:"center"}}>Reg.Number</th>
                      
                        <th style={{textAlign:"center"}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
  {currentDoctors.map((doctor, index) => (
    <tr key={doctor.id}>
      <td>{indexOfFirst + index + 1}</td>
      <td>{doctor.diagnosticCenterName} </td>
      <td>{doctor.diagnosticCenterAddress}</td>
      <td>{doctor.registrationNumber}</td>
    
      <td>
        <button
          onClick={() => setSelectedDoc(doctor)}
          className="btn btn-icon btn-sm"
          title="View"
        >
          <i className="fa fa-eye" />
        </button>

         <button onClick={()=>{setEditModal(true);setSelectedDoc(doctor)}}
                                  type="button"
                                  className="btn btn-icon btn-sm"
                                  title="Edit"
                                >
                                  <i className="fa fa-edit" />
                                </button>
      </td>
    </tr>
  ))}
</tbody>

                  </table>
                  <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(doctors.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(doctors.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>

                </div>
              </div>
            </div>
          </div>
        </div>
        {
          selectedDoc &&
          <div style={{position:"fixed",padding:"25px",zIndex:999,backgroundColor:"white",top:"200px",left:"35vw",border:"1px solid black",borderRadius:"10px",width:"35vw"}}>
           <p onClick={()=>setSelectedDoc(null)} 
           style={{fontWeight:"600",color:"gray",right:0,top:2,position:"absolute",padding:"10px",cursor:"pointer"}}>X</p>
            <p style={{fontSize:"20px",fontWeight:"600",display:"flex",gap:'20px'}}>{selectedDoc.hospitalName} <p style={{fontWeight:"600",color:"gray"}}>{selectedDoc.age}</p></p>
            
            <p style={{fontWeight:"300",color:"black"}}>{selectedDoc.bankName},{selectedDoc.bankBranch},{selectedDoc.bankAccountNumber}</p>
              <p style={{fontWeight:"300",color:"black"}}>{selectedDoc.ifscCode},{selectedDoc.upiId}</p>
            

          </div>
        }

        {
          editmodal &&
           <div style={{position:"fixed",padding:"25px",zIndex:999,backgroundColor:"white",top:"200px",left:"35vw",border:"1px solid black",borderRadius:"10px",width:"35vw"}}>
            <p onClick={()=>{setSelectedDoc(null);setEditModal(false)}} 
           style={{fontWeight:"600",color:"gray",right:0,top:2,position:"absolute",padding:"10px",cursor:"pointer"}}>X</p>

            {/*
           <label>Proffetion:
            <input type="text" value={editprofession} onChange={(e)=>setEditprofession(e.target.value)} />
           </label>
           <label>Specialization:
            <input type="text" value={editSpecialization} onChange={(e)=>setEditSpecialization(e.target.value)} />
           </label>
           <label>Degree:
            <input type="text" value={editDegree} onChange={(e)=>setEditDegree(e.target.value)} />
           </label>
           <label>RelationWithCo:
            <input type="text" value={editrelationWithCo} onChange={(e)=>setEditrelationWithCo(e.target.value)} />
           </label>
           <label>NumberOfCo:
            <input type="text" value={editnumberOfCo} onChange={(e)=>setEditnumberOfCo(e.target.value)} />
           </label>
           <label>AadhaarImage:
            <input type="file" onChange={(e)=>setEditadharimage(e.target.files[0])} />
           </label>

           <p  onClick={habdleEditDoctor}
           style={{padding:"10px",borderRadius:"8px",backgroundColor:"#1972f7ff",color:"white",fontWeight:"600",width:"fit-content",cursor:"pointer"}}>Submit</p>
             */}
            </div>
        }
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default DiagnosticCenter
